import clsx from 'clsx';
import { baseButtonClass } from '../index';
import { RemoteButton } from '../../../../hooks/useRemote';

interface Props {
  buttons: RemoteButton[];
  onClick(commandId: number): void;
}

export const NumberPad = ({ buttons, onClick }: Props) => {
  return (
    <div
      className={clsx('col-span-full grid grid-cols-3 h-fit my-4', {
        'gap-1': window.devicePixelRatio > 1,
        'gap-4': window.devicePixelRatio <= 1,
      })}
    >
      {buttons.map((button, index) => (
        <button
          key={`numpad-button-${index + 1}`}
          className={clsx(
            baseButtonClass,
            'w-auto px-1 rounded-full text-ellipsis overflow-hidden',
            {
              ['!text-[0.45rem] tracking-wide']:
                button.name === 'DELETE' || button.name === 'ENTER',
              'scale-75': window.devicePixelRatio > 1,
            }
          )}
          onClick={() => onClick(button.id)}
          onTouchEnd={() => onClick(button.id)}
        >
          {button.name}
        </button>
      ))}
    </div>
  );
};
